import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(site)/rivers/RiversIndexClient.tsx");
